import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route, BrowserRouter } from 'react-router';
import Home from './app/page';
import CustomizePage from './app/customize/page';
import CheckoutSuccessPage from './app/checkout/success/page';

// Import styles
import './app/globals.css';

// Main App component with React Router
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/customize" element={<CustomizePage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
      </Routes>
    </BrowserRouter>
  );
};

// Render the App
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
